/**
 * Rich SEO page registry
 * =======================
 * Maps high-traffic SEO slugs to bespoke, hand-built rich page components.
 * SammenlignPage looks up the slug here first; if there's a match, it renders
 * the rich page. Otherwise it falls back to the generic templates.
 */

import GennemsnitligElpris2026 from './pages/GennemsnitligElpris2026';
import V2GGuide from './pages/V2GGuide';
import HvadErDK1DK2 from './pages/HvadErDK1DK2';
import ZaptecGo2Nordjylland from './pages/ZaptecGo2Nordjylland';
import LadeboksV2GReady from './pages/LadeboksV2GReady';
import LadeboksInstallation from './pages/LadeboksInstallation';
import ElbilBudgetHovedstaden from './pages/ElbilBudgetHovedstaden';
import OpladningTeslaModel3 from './pages/OpladningTeslaModel3';
import OpladningHjemmeHovedstaden from './pages/OpladningHjemmeHovedstaden';
import ZaptecGoVsGo2 from './pages/ZaptecGoVsGo2';
import ZaptecVsEasee from './pages/ZaptecVsEasee';
import ZaptecGo2VsEaseePeak from './pages/ZaptecGo2VsEaseePeak';
import EaseeChargeLiteVsHome from './pages/EaseeChargeLiteVsHome';
import ElbilVsDiesel from './pages/ElbilVsDiesel';
import LadeboksInstallationPris from './pages/LadeboksInstallationPris';
import OpladningVwId3 from './pages/OpladningVwId3';
import NexBlueVsZaptecGo from './pages/NexBlueVsZaptecGo';
import ElselskaberOversigt from './pages/ElselskaberOversigt';

const REGIONS = ['hovedstaden', 'sjaelland', 'syddanmark', 'midtjylland', 'nordjylland'];

// Build a base + all regional geo-variants for a slug -> component mapping.
const withRegions = (base, Component) => {
  const map = { [base]: Component };
  REGIONS.forEach((r) => { map[`${base}-${r}`] = Component; });
  return map;
};

export const RICH_PAGES = {
  'gennemsnitlig-elpris-2026': GennemsnitligElpris2026,
  'v2g-guide': V2GGuide,
  'hvad-er-dk1-dk2': HvadErDK1DK2,
  'ladeboks-zaptec_go_2-nordjylland': ZaptecGo2Nordjylland,
  'ladeboks-v2g-ready': LadeboksV2GReady,
  'ladeboks-installation': LadeboksInstallation,
  'elbil-budget-hovedstaden': ElbilBudgetHovedstaden,
  'opladning-tesla-model-3': OpladningTeslaModel3,
  'hvad-koster-opladning-hjemme-hovedstaden': OpladningHjemmeHovedstaden,
  // ── Newly enriched bespoke pages (base + regional geo-variants) ──
  ...withRegions('zaptec-go-vs-go-2', ZaptecGoVsGo2),
  ...withRegions('zaptec-vs-easee', ZaptecVsEasee),
  ...withRegions('zaptec-go-2-vs-easee-peak', ZaptecGo2VsEaseePeak),
  ...withRegions('easee-charge-lite-vs-home', EaseeChargeLiteVsHome),
  ...withRegions('elbil-vs-diesel', ElbilVsDiesel),
  ...withRegions('ladeboks-installation-pris', LadeboksInstallationPris),
  ...withRegions('opladning-vw-id3', OpladningVwId3),
  ...withRegions('nexblue-edge-2-vs-zaptec-go', NexBlueVsZaptecGo),
  ...withRegions('elselskaber-oversigt-2026', ElselskaberOversigt),
};
// NOTE: All page_type==='competitor_comparison' slugs (every competitor × every
// city/region) are routed to CompetitorVsEnkel directly in SammenlignPage, so
// they don't need individual entries here. CompetitorVsEnkel is imported there.

export function getRichPage(slug) {
  return RICH_PAGES[slug] || null;
}